const FACILITY_STORAGE_KEY = 'selected-facility-identifier'

export const facilityStorage = {
	get: (): string | null => {
		try {
			return localStorage.getItem(FACILITY_STORAGE_KEY)
		} catch {
			return null
		}
	},
	set: (identifier: string): void => {
		try {
			localStorage.setItem(FACILITY_STORAGE_KEY, identifier)
		} catch {
			/* silent */
		}
	},
	remove: (): void => {
		try {
			localStorage.removeItem(FACILITY_STORAGE_KEY)
		} catch {
			/* silent */
		}
	},
}
